import { Link } from '@tanstack/react-router'

export default function Header() {
  return (
    <header className="px-5 py-4 flex items-center justify-between z-1 bg-white border-b border-gray-300">
      <Link to="/" className="relative">
        <img
          src="/img/logo.png"
          alt="ANEX"
          height={80}
          width={0}
          className="h-[30px] w-auto object-contain"
        />
      </Link>

      <nav className="flex items-center justify-center gap-4">
        <Link to="/contact" className="hover:text-link-hover-primary">
          Contact us
        </Link>
        <a
          href={window['OSS_URL']}
          className="btn btn-primary text-base"
          target="_blank"
          rel="nofollow, noreferrer"
        >
          Login
        </a>
      </nav>
    </header>
  )
}
